// extracted by mini-css-extract-plugin
module.exports = {"videoWrap":"media_videoWrap__3Yi_R","left":"media_left__uZvYr","right":"media_right__kyltE"};